
(function ccRecoVariantHover() {
  const IMAGE_SECTION = '.ccReco-prodImg-section, .ccReco-productImage-section';
  const MAIN_IMAGE = '.cc-main-image, .ccReco-product-image';
  const HOVER_IMAGE = '.cc-hover-image';
  const PRODUCT_LINK = '.ccReco-prodImg-link, .ccReco-productImage-link, a[href*="/products/"]';
  const productCache = new Map();

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (!productCache.has(handle)) {
      productCache.set(
        handle,
        fetch(`/products/${handle}.js`)
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null)
      );
    }
    return productCache.get(handle);
  }

  function fileKey(src) {
    if (!src) return '';
    return src
      .split('?')[0]
      .split('/')
      .pop()
      .replace(/_(?:large|medium|small|grande|compact|icon|thumb|pico|\d+x\d*)(?=\.\w+$)/, '');
  }

  function productImageList(product) {
    if (!product) return [];
    if (Array.isArray(product.media) && product.media.length) {
      return product.media
        .filter((media) => media && (media.media_type === 'image' || media.src))
        .map((media) => ({ src: media.src, alt: media.alt || '' }));
    }
    if (Array.isArray(product.images) && product.images.length) {
      return product.images.map((image) => {
        if (typeof image === 'string') return { src: image, alt: '' };
        return { src: image.src || image, alt: image.alt || '' };
      });
    }
    return [];
  }

  function siblingImageSrc(product, mainSrc) {
    const images = productImageList(product);
    if (images.length < 2) return null;

    const shown = images.find((media) => fileKey(media.src) === fileKey(mainSrc)) || images[0];
    const color = (shown.alt || '').trim().toLowerCase();
    const sibling = color
      ? images.find((media) => media !== shown && (media.alt || '').trim().toLowerCase() === color)
      : null;

    if (sibling) return sibling.src;
    const next = images.find((media) => fileKey(media.src) !== fileKey(shown.src));
    return next ? next.src : null;
  }

  function hoverImageEl(section) {
    return section.querySelector(HOVER_IMAGE) || section.querySelectorAll('img')[1] || null;
  }

  function disableHover(section, hoverImage) {
    if (!section) return;
    delete section.dataset.hoverReady;
    section.dataset.hoverNone = 'true';
    if (!hoverImage) return;
    hoverImage.removeAttribute('src');
    hoverImage.removeAttribute('srcset');
    hoverImage.style.setProperty('display', 'none', 'important');
  }

  function enableHover(section, hoverImage, src) {
    if (!section || !hoverImage || !src) return;
    delete section.dataset.hoverNone;
    hoverImage.src = `${src}${src.includes('?') ? '&' : '?'}width=720`;
    hoverImage.addEventListener(
      'error',
      () => disableHover(section, hoverImage),
      { once: true }
    );
    section.dataset.hoverReady = 'true';
  }

  function productHandle(section) {
    const link = section.querySelector(PRODUCT_LINK) || section.closest('a[href*="/products/"]');
    if (!link || !link.href) return '';
    const parts = new URL(link.href, window.location.origin).pathname.split('/products/');
    return (parts[1] || '').split('/')[0];
  }

  function guardMainImage(section) {
    const mainImage = section.querySelector(MAIN_IMAGE);
    if (!mainImage || mainImage.dataset.ccOrigSrc) return mainImage;
    mainImage.dataset.ccOrigSrc = mainImage.getAttribute('src') || '';
    mainImage.addEventListener('error', () => {
      const original = mainImage.dataset.ccOrigSrc;
      if (original && mainImage.getAttribute('src') !== original) {
        mainImage.src = original;
      }
      disableHover(section, hoverImageEl(section));
    });
    return mainImage;
  }

  async function prepareHover(section) {
    const mainImage = guardMainImage(section);
    const hoverImage = hoverImageEl(section);
    if (!mainImage) return;

    if (section.dataset.hoverFor === mainImage.src) {
      if (section.dataset.hoverNone) disableHover(section, hoverImage);
      return;
    }
    section.dataset.hoverFor = mainImage.src;
    delete section.dataset.hoverReady;

    const swatches = Array.from(
      section.closest('.ccReco-singleProduct-card')?.querySelectorAll('.ccReco-varent-image') || []
    );
    if (swatches.length > 1) {
      const active = swatches.findIndex((swatch) =>
        swatch.classList.contains('ccReco-varent-image--active'));
      const from = active < 0 ? 0 : active;
      const next = swatches.slice(from + 1).concat(swatches.slice(0, from))
        .find((swatch) => swatch.getAttribute('src'));

      if (next && hoverImage) {
        enableHover(section, hoverImage, next.getAttribute('src'));
        return;
      }
    }

    const product = await fetchProduct(productHandle(section));
    if (!product || section.dataset.hoverFor !== mainImage.src) return;

    const src = siblingImageSrc(product, mainImage.src);
    if (!src || fileKey(src) === fileKey(mainImage.src)) {
      disableHover(section, hoverImage);
      return;
    }

    if (hoverImage) enableHover(section, hoverImage, src);
  }

  function processRoot(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches?.(IMAGE_SECTION)) prepareHover(root);
    root.querySelectorAll(IMAGE_SECTION).forEach((section) => {
      prepareHover(section);
    });
  }

  document.addEventListener(
    'mouseover',
    (event) => {
      const section = event.target.closest?.(IMAGE_SECTION);
      if (section) prepareHover(section);
    },
    { passive: true }
  );

  document.addEventListener(
    'focusin',
    (event) => {
      const section = event.target.closest?.(IMAGE_SECTION);
      if (section) prepareHover(section);
    },
    { passive: true }
  );

  // Search cards (.cc-product-card-img) can point the hover <img> at a missing image2 URL; fall back to the main photo.
  // Listening to load too clears the flag when ConvertCart reuses the card for another product.
  ['error', 'load'].forEach((type) => {
    document.addEventListener(
      type,
      (event) => {
        const image = event.target;
        if (image.tagName !== 'IMG' || !image.closest('.cc-hover-image')) return;
        const card = image.closest('.cc-product-card-img');
        if (!card) return;
        card.toggleAttribute('data-hover-none', type === 'error');
      },
      true
    );
  });

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.('.ccReco-main-section, .cc-productReco, ' + IMAGE_SECTION) || node.querySelector?.(IMAGE_SECTION)) {
          processRoot(node);
        } else {
          const section = node.closest?.(IMAGE_SECTION);
          if (section) prepareHover(section);
        }
      });
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
